import { useState, useEffect } from 'react';

/**
 * Hook to detect if viewport is wider than a threshold.
 * @param threshold - Minimum width in pixels (default 1650)
 * @returns boolean indicating if viewport is at or above threshold
 */
export function useIsWideViewport(threshold: number = 1650): boolean {
    const [isWide, setIsWide] = useState(() =>
        typeof window !== 'undefined' ? window.innerWidth >= threshold : false
    );

    useEffect(() => {
        const handleResize = () => {
            setIsWide(window.innerWidth >= threshold);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [threshold]);

    return isWide;
}
